import { Theme } from './types';
import themeObject from './theme.json';

export const theme = themeObject as Theme;
export default theme;
